"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gorizia": {
    "e8abc2f1": [{
      "hkey": "4ba20426",
      "slug": "gorizia",
      "name": "Gorizia",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "4ba20426",
      "slug": "gorizia",
      "name": "Gorizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8337a498": [{
      "hkey": "82d27028",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "82d27028",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "214e949e": [{
      "hkey": "4ba20426",
      "slug": "gorizia",
      "name": "Gorizia",
      "primary": true,
      "skipSearch": false
    }],
    "oslavia": [{
      "hkey": "4ba20426",
      "slug": "gorizia",
      "name": "Gorizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43597dc4": [{
      "hkey": "4ba20426",
      "slug": "gorizia",
      "name": "Gorizia",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "4ba20426",
      "slug": "gorizia",
      "name": "Gorizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b02e55bc": [{
      "hkey": "050bd3c6",
      "slug": "montesanto-piuma",
      "name": "Montesanto-Piuma",
      "primary": true,
      "skipSearch": false
    }],
    "piuma": [{
      "hkey": "050bd3c6",
      "slug": "montesanto-piuma",
      "name": "Montesanto-Piuma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "144f0091": [{
      "hkey": "4ba20426",
      "slug": "gorizia",
      "name": "Gorizia",
      "primary": true,
      "skipSearch": false
    }],
    "san-mauro": [{
      "hkey": "4ba20426",
      "slug": "gorizia",
      "name": "Gorizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;